import { useModel as _useModel, useCssVars as _useCssVars, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, normalizeClass as _normalizeClass, unref as _unref, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "multilingual-input-component" };
const _hoisted_2 = { class: "rc-langInput rc-large-input" };
const _hoisted_3 = ["id", "disabled", "required", "maxlength", "placeholder", "aria-invalid", "aria-describedby"];
const _hoisted_4 = ["id", "disabled", "required", "maxlength", "placeholder", "rows", "aria-invalid", "aria-describedby"];
const _hoisted_5 = ["aria-expanded"];
const _hoisted_6 = { class: "dropdown-menu rc-langPick" };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = { class: "rc-text" };
import { toRem } from "@/common/helpers/style";
import { vTooltip } from "@/common/directives/tip-directive";
import { onClickOutside, useTextareaAutosize } from "@vueuse/core";
import { computed, onMounted, ref, useTemplateRef, watch } from "vue";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'MultilingualInput',
    props: /*@__PURE__*/ _mergeModels({
        locale: {},
        locales: {},
        inputId: {},
        type: { default: "input" },
        disabled: { type: Boolean },
        required: { type: Boolean },
        maxLength: {},
        placeholder: { default: "" },
        inputClass: { default: () => [] },
        rows: {},
        autoResize: { type: Boolean },
        textareaMaxHeight: {},
        ariaInvalid: { type: Boolean },
        ariaDescribedby: {}
    }, {
        "modelValue": { required: true },
        "modelModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(["update:locale"], ["update:modelValue"]),
    setup(__props, { emit: __emit }) {
        _useCssVars(_ctx => ({
            "v1e3ec980": (textareaMaxHeightCSS.value),
            "v0d27c612": (textareaMinHeightCSS.value)
        }));
        const props = __props;
        const emit = __emit;
        const model = _useModel(__props, "modelValue");
        const maxLength = computed(() => props.maxLength ?? (props.type === "textarea" ? 500 : 50));
        const selectedLocale = ref(props.locale.toLowerCase()); // TODO: use defineModel instead
        const onLocaleSelected = (str) => (selectedLocale.value = str.toLowerCase());
        const defaultLocale = props.locale.toLowerCase();
        const currentValue = ref(model.value[props.locale.toLowerCase()]);
        watch(selectedLocale, (newValue) => {
            currentValue.value = model.value[newValue.toLowerCase()] || "";
            emit("update:locale", newValue);
        });
        watch(() => model.value[selectedLocale.value.toLowerCase()], (newVal) => (currentValue.value = newVal ?? ""));
        watch(() => props.locale, (newLocale) => (selectedLocale.value = newLocale.toLowerCase()));
        const hasValue = (locale) => {
            return !!model.value[locale.toLowerCase()];
        };
        const valueUpdated = () => {
            model.value = { ...model.value, [selectedLocale.value.toLowerCase()]: currentValue.value };
        };
        const isDefaultLocaleSelected = computed(() => defaultLocale === selectedLocale.value.toLowerCase());
        const inputTooltip = computed(() => isDefaultLocaleSelected.value ? "" : `${defaultLocale.toUpperCase()}: ${model.value[defaultLocale]}`);
        const isHighlighted = computed(() => 
        // Non-default lang selected, default lang has string, current lang does not
        !isDefaultLocaleSelected.value &&
            !!model.value[defaultLocale] &&
            model.value[defaultLocale].length > 1 &&
            currentValue.value.length < 1);
        const textareaRef = useTemplateRef("textarea");
        const textareaMaxHeightCSS = computed(() => toRem(props.textareaMaxHeight ?? 300));
        const textareaMinHeightCSS = ref("");
        useTextareaAutosize({
            element: computed(() => (props.autoResize ? textareaRef.value : null)),
            input: currentValue
        });
        onMounted(() => {
            if (!props.autoResize || !props.rows || !textareaRef.value)
                return;
            const style = window.getComputedStyle(textareaRef.value);
            const lineHeight = parseFloat(style.lineHeight);
            const paddingTop = parseFloat(style.paddingTop);
            const paddingBottom = parseFloat(style.paddingBottom);
            if (!isNaN(lineHeight)) {
                textareaMinHeightCSS.value = `${props.rows * lineHeight + paddingTop + paddingBottom}px`;
            }
        });
        const localeDropdownRef = ref(null);
        const isLocaleDropdownOpen = ref(false);
        onClickOutside(localeDropdownRef, () => {
            isLocaleDropdownOpen.value = false;
        });
        const selectLocale = (lang) => {
            onLocaleSelected(lang);
            isLocaleDropdownOpen.value = false;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (__props.type === 'input')
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            id: __props.inputId,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((currentValue).value = $event)),
                            type: "text",
                            disabled: __props.disabled,
                            required: __props.required,
                            maxlength: maxLength.value,
                            placeholder: __props.placeholder,
                            "aria-invalid": __props.ariaInvalid,
                            "aria-describedby": __props.ariaDescribedby,
                            class: _normalizeClass(["rc-langField form-control", [__props.inputClass, { 'rc-highlight': isHighlighted.value }]]),
                            dir: "auto",
                            onInput: valueUpdated
                        }, null, 42, _hoisted_3)), [
                            [_vModelText, currentValue.value],
                            [_unref(vTooltip), inputTooltip.value]
                        ])
                        : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                            key: 1,
                            ref: "textarea",
                            id: __props.inputId,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((currentValue).value = $event)),
                            disabled: __props.disabled,
                            required: __props.required,
                            maxlength: maxLength.value,
                            placeholder: __props.placeholder,
                            rows: __props.rows,
                            "aria-invalid": __props.ariaInvalid,
                            "aria-describedby": __props.ariaDescribedby,
                            class: _normalizeClass(["rc-langField form-control", [__props.inputClass, { 'rc-highlight': isHighlighted.value, 'rc-autoResize': __props.autoResize }]]),
                            dir: "auto",
                            onInput: valueUpdated
                        }, null, 42, _hoisted_4)), [
                            [_vModelText, currentValue.value],
                            [_unref(vTooltip), inputTooltip.value]
                        ]),
                    (__props.locales && __props.locales.length > 1)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            ref_key: "localeDropdownRef",
                            ref: localeDropdownRef,
                            class: _normalizeClass(["dropdown rc-langDropdown", { open: isLocaleDropdownOpen.value }])
                        }, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "rc-langPick-label",
                                "aria-expanded": isLocaleDropdownOpen.value,
                                "aria-haspopup": "listbox",
                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (isLocaleDropdownOpen.value = !isLocaleDropdownOpen.value), ["stop"]))
                            }, _toDisplayString(selectedLocale.value), 9, _hoisted_5),
                            _createElementVNode("ul", _hoisted_6, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.locales, (l) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        key: l.lang
                                    }, [
                                        _createElementVNode("a", {
                                            href: "#",
                                            class: _normalizeClass([
                                                'rc-icon',
                                                'rc-link-' + l.lang,
                                                {
                                                    'rc-completed': hasValue(l.lang),
                                                    'rc-incomplete': !hasValue(l.lang),
                                                    'rc-currentLang': selectedLocale.value.toLowerCase() == l.lang.toLowerCase()
                                                }
                                            ]),
                                            onClick: _withModifiers(($event) => (selectLocale(l.lang)), ["prevent"])
                                        }, [
                                            _createElementVNode("span", _hoisted_8, _toDisplayString(l.lang) + " - " + _toDisplayString(l.label), 1)
                                        ], 10, _hoisted_7)
                                    ]));
                                }), 128))
                            ])
                        ], 2))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
